import { Edit } from 'lucide-react'
import { Badge } from '@/shared/components/ui/badge'
import { Button } from '@/shared/components/ui/button'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/shared/components/ui/table'
import type { Fuente } from '@/modules/bd-unificada/types/fuente'
import { TIPOS_FUENTE } from '@/modules/bd-unificada/types/fuente'

interface FuentesTableProps {
  fuentes: Fuente[]
  onEdit: (fuente: Fuente) => void
}

function labelTipo(tipo: string): string {
  return TIPOS_FUENTE.find((t) => t.value === tipo)?.label ?? tipo
}

export function FuentesTable({ fuentes, onEdit }: FuentesTableProps) {
  return (
    <div className="rounded-md border border-gray-300 dark:border-gray-700 overflow-hidden">
      <Table>
        <TableHeader className="bg-gray-100 dark:bg-[hsl(220,15%,16%)]">
          <TableRow>
            <TableHead>Nombre</TableHead>
            <TableHead>Tipo</TableHead>
            <TableHead>Prioridad</TableHead>
            <TableHead>Comportamiento</TableHead>
            <TableHead>Estado</TableHead>
            <TableHead className="text-right">Acciones</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {fuentes.map((f) => (
            <TableRow key={f.id}>
              <TableCell className="font-medium">{f.nombre}</TableCell>
              <TableCell>
                <Badge className="badge-gradient hover:opacity-90 capitalize">
                  {labelTipo(String(f.tipo))}
                </Badge>
              </TableCell>
              <TableCell>{f.prioridad}</TableCell>
              <TableCell className="text-sm text-muted-foreground">
                {f.prioridad >= 7 ? 'Actualización automática' : 'Va a la cola de revisión'}
              </TableCell>
              <TableCell>
                <Badge variant={f.activa ? 'default' : 'secondary'}>
                  {f.activa ? 'Activa' : 'Inactiva'}
                </Badge>
              </TableCell>
              <TableCell className="text-right">
                <Button size="sm" variant="ghost" onClick={() => onEdit(f)}>
                  <Edit className="h-4 w-4" />
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
}
